import { Constants } from "../model/Constants";
import { TypeDef_AgentBubble } from "../ui/bubbleviews/AgentBubble";
import { debounce } from "./Misc";
import pubSubGlobal from "./pubSubGlobal";

class MultipleMessagesScrollHandler {
    enhancedScrollingDelay: number | null;

    agentMessagesQueue: TypeDef_AgentBubble[];

    inboundMessagesHandler: (A?: string) => void;

    constructor(enhancedScrollingDelay: number) {
        this.enhancedScrollingDelay = enhancedScrollingDelay;
        this.agentMessagesQueue = [];
        this.inboundMessagesDebounce();
    }

    subscribeToAgentBubbleCreation(): number {
        const onAgentBubbleSubscriptionId = pubSubGlobal.subscribe((agentBubble: TypeDef_AgentBubble) => {
            this.handleInboundMessages(agentBubble);
        }, Constants.AGENT_OR_RICH_MEDIA_MESSAGE_RENDERED);
        return onAgentBubbleSubscriptionId;
    }

    /* this method returns the first message's scroll position of multiple messages which are received in enhancedScrollingDelay timeframe, 
        if aggregate height of all messages is greater than chat window height */
    getInboundMessageHead(chatHeight: number): null | number {
        let msgAggregateHeight = 0;
        let messageHead: null | number;

        for (let i = 0; i < this.agentMessagesQueue.length; i++) {
            msgAggregateHeight += this.agentMessagesQueue[i].clientHeight;
        }

        // scrolling to a bit above i.e 10px so that alias is clearly displayed
        if (msgAggregateHeight > chatHeight) {
            messageHead = this.agentMessagesQueue[0].offsetTop + chatHeight - 10;
        }
        return messageHead;
    }

    resetQueueAndTimer() {
        this.inboundMessagesHandler("clear-timer");
        this.resetAgentMessageQueue();
    }

    private inboundMessagesDebounce() {
        this.inboundMessagesHandler = debounce(() => {
            this.resetAgentMessageQueue();
        }, this.enhancedScrollingDelay);
    }

    private handleInboundMessages(agentBubble: TypeDef_AgentBubble) {
        this.agentMessagesQueue.push(agentBubble);
        this.inboundMessagesHandler();
    }

    private resetAgentMessageQueue() {
        this.agentMessagesQueue = [];
    }
}

export default MultipleMessagesScrollHandler;
